import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useSeasonsAnimation from './useSeasonsAnimation/useSeasonAnimation';

import SeasonSelect from '../SeasonSelect';
import EpisodeRow from '../EpisodeRow';

import './Seasons.scss';

import { ISeason } from '../../utils/models';
export interface ISeasonProps {
  seasons: ISeason[];
  analytics: any;
}

const Seasons = ({ seasons, analytics }: ISeasonProps) => {
  const [currentSeasonIndex, setCurrentSeasonIndex] = useState<number>(0);
  const [ariaAnnouncement, setAriaAnnouncement] = useState<string>('');
  const { listVariants, episodeVariants } = useSeasonsAnimation();
  const hasLoaded = useRef<boolean>(false);

  useEffect(() => {
    if (hasLoaded.current) {
      setAriaAnnouncement(
        `${seasons[currentSeasonIndex].name} episode list has loaded.`
      );
      setTimeout(() => {
        setAriaAnnouncement('');
      }, 500);
    }

    // prevents aria-live region from announcing on initial render
    hasLoaded.current = true;
  }, [currentSeasonIndex, setAriaAnnouncement, seasons]);

  const currentSeason = seasons[currentSeasonIndex]?.episodes.map(
    (episode, i) => (
      <motion.li
        variants={episodeVariants}
        className="episodes__item"
        key={episode.id}
      >
        <EpisodeRow episode={episode} index={i} analytics={analytics} key={episode.id} />
      </motion.li>
    )
  );

  return (
    <section className="seasons">
      <div className="visually-hidden" aria-live="polite">
        {ariaAnnouncement}
      </div>

      {seasons.length > 1 ? (
        <SeasonSelect
          value={currentSeasonIndex}
          options={seasons}
          onSelect={setCurrentSeasonIndex}
        />
      ) : (
        <h3 className="seasons__title">{seasons[0].name}</h3>
      )}

      <AnimatePresence initial={false} mode="wait">
        <motion.ul
          className="episodes"
          key={currentSeasonIndex}
          variants={listVariants}
          initial="enter"
          animate="center"
          exit="exit"
        >
          {currentSeason}
        </motion.ul>
      </AnimatePresence>
    </section>
  );
};

export default Seasons;
